import clsx from 'clsx';

import styles from './shell.module.css';

/**
 * Server rail — vertical column of server icons. Phase 1 ships a single
 * hardcoded server per decision 23.1-#2 (Gateway + SQLite); the rail is a
 * structural placeholder for the real multi-server UX in Phase 5.
 */
export function ServerRail(): JSX.Element {
  return (
    <nav className={styles.serverRail} aria-label="Servers">
      <div
        className={clsx(styles.serverIcon, styles.serverIconActive)}
        title="MyTile (Phase 1 single-server)"
        role="button"
        aria-pressed="true"
        aria-label="MyTile server"
        tabIndex={0}
      >
        M
      </div>
    </nav>
  );
}
